const formatFormLabel = (text, showColon) => `${text}${showColon ? ':' : ''}`

export default formatFormLabel
